// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"bdb176eb","220":"aabca793","339":"a7c1aca9","345":"711fa4b5","701":"7558453d","906":"481de26c"}[chunkId] + ".chunk.css";
};